import { ElementType, type Element } from './element';
import type { Events } from './events';
import type { HelperPoint } from './helper-point';

type ImportedMotionKind = 'vehicle' | 'camera';

const getRootKind = (root: HelperPoint | null): ImportedMotionKind | null => {
    if (!root) {
        return null;
    }

    if ((root as any).vehicleMotionController) {
        return 'vehicle';
    }

    if ((root as any).cameraMotionController) {
        return 'camera';
    }

    return null;
};

const root = (element: Element | null | undefined): HelperPoint | null => {
    let current: any = element ?? null;

    for (let i = 0; i < 64 && current; i++) {
        if (current.type === ElementType.helper && getRootKind(current as HelperPoint)) {
            return current as HelperPoint;
        }

        current = current.parentElement ?? null;
    }

    return null;
};

const kind = (element: Element | null | undefined): ImportedMotionKind | null => {
    return getRootKind(root(element));
};

const displayTarget = (element: Element | null | undefined): HelperPoint | null => {
    const motionRoot = root(element);
    const motionKind = getRootKind(motionRoot);

    if (!motionRoot || !motionKind) {
        return null;
    }

    if (element?.type === ElementType.helper && element !== motionRoot && (element as HelperPoint).animated) {
        return element as HelperPoint;
    }

    if (motionKind === 'vehicle') {
        return ((motionRoot as any).vehicleMotionAnimatedHelpers?.body as HelperPoint | undefined) ?? null;
    }

    return ((motionRoot as any).cameraMotionAnimatedHelpers?.body as HelperPoint | undefined) ?? null;
};

const registerImportedMotionEvents = (events: Events) => {
    events.function('importedMotion.root', (element: Element | null | undefined) => {
        return root(element);
    });

    events.function('importedMotion.displayTarget', (element: Element | null | undefined) => {
        return displayTarget(element);
    });

    events.function('importedMotion.kind', (element: Element | null | undefined) => {
        return kind(element);
    });
};

export { displayTarget, kind, registerImportedMotionEvents, root };
export type { ImportedMotionKind };